import { TextField, TextFieldProps } from "../../inputs";
import { TableColumnDef } from "../types";
import { defaultPrettifyFilterValue } from "../utils";

import styles from "./styles.module.scss";

export function TextColumn<T extends object = {}>(
  { textFieldProps, ...params }: TableColumnDef<T> & { textFieldProps?: TextFieldProps },
): TableColumnDef<T> {
  return {
    enableColumnFilter: true,
    minSize: 50,
    cell: ({ renderValue }) => <span className={styles.content}>{renderValue() as any}</span>,
    ...params,
    meta: {
      defaultFilterFn: "includesString",
      additionalFilterFn: [ "includesString", "equalsString", "includesStringSensitive" ],
      prettifyFilterValue: ((v: any, filterFn) => {
        // if (filterFn === "includesString") {
        //   return {
        //     value: `%${defaultPrettifyFilterValue(v, filterFn).value}%`,
        //   };
        // }

        return defaultPrettifyFilterValue(v, filterFn);
      }),
      Filter: ({ label, value, onChange, autoFocus }) => (
        <TextField
          autoFocus={autoFocus}
          label={label}
          value={value as any}
          onChange={onChange}
          {...textFieldProps}
        />
      ),
      ...params?.meta,
    },
  };
}
